import * as React from "react";
import { cn } from "@app/ui/lib/Utils";

export interface LogoProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  size?: "sm" | "md" | "lg";
  animate?: boolean;
}

const SIZE = {
  sm: "h-6 w-6 rounded-md",
  md: "h-10 w-10 rounded-lg",
  lg: "h-14 w-14 rounded-xl",
} as const;

const Logo = React.forwardRef<HTMLImageElement, LogoProps>(
  ({ size = "md", animate = true, className, style, ...props }, ref) => {
    const [visible, setVisible] = React.useState(!animate);

    React.useLayoutEffect(() => {
      if (animate) {
        requestAnimationFrame(() => setVisible(true));
      }
    }, [animate]);

    return (
      <img
        ref={ref}
        src="/logo.png"
        alt="withtask"
        className={cn(
          SIZE[size],
          "transition-all duration-500 ease-out",
          visible ? "opacity-100 scale-100" : "opacity-0 scale-90",
          className,
        )}
        style={style}
        {...props}
      />
    );
  },
);
Logo.displayName = "Logo";

export { Logo };
